'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Feed;

var _reactHyperscript = require('react-hyperscript');

var _reactHyperscript2 = _interopRequireDefault(_reactHyperscript);

var _masonCanvas = require('../mason-canvas');

var _masonCanvas2 = _interopRequireDefault(_masonCanvas);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function Feed(props) {
  return (0, _reactHyperscript2.default)(_masonCanvas2.default, props);
}